export default __webpack_public_path__ + "static/media/JASO.d2ec7887.png";